import React from 'react';
import { ContactForm } from '../components/ContactForm';
export function Contact() {
  return <div className="w-full bg-white" data-id="element-1213">
      {/* Header */}
      <section className="cream-bg py-20 md:py-28 w-full" data-id="element-1214">
        <div className="container mx-auto px-4" data-id="element-1215">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1216">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight elegant-heading" data-id="element-1217">
              Get In Touch
            </h1>
            <div className="elegant-divider" data-id="element-1218"></div>
            <p className="text-xl navy-text max-w-2xl mx-auto" data-id="element-1219">
              We'd love to hear about your brand's story and how we can help
              elevate your narrative.
            </p>
          </div>
        </div>
      </section>
      {/* Contact Form Section */}
      <section className="py-20 w-full" data-id="element-1220">
        <div className="container mx-auto px-4" data-id="element-1221">
          <div className="max-w-2xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-lg luxury-border elegant-card" data-id="element-1222">
            <div className="mb-10 text-center" data-id="element-1223">
              <h2 className="text-3xl font-bold mb-4 elegant-heading" data-id="element-1224">
                Send Us a Message
              </h2>
              <div className="w-16 h-1 accent-bg mx-auto mb-6" data-id="element-1225"></div>
              <p className="text-gray-700" data-id="element-1226">
                Share your vision with us, and we'll craft a narrative that
                resonates with your audience.
              </p>
            </div>
            <ContactForm data-id="element-1227" />
          </div>
        </div>
      </section>
      {/* Elegant Separator */}
      <section className="py-16 w-full" data-id="element-1228">
        <div className="container mx-auto px-4" data-id="element-1229">
          <div className="max-w-4xl mx-auto flex items-center justify-center" data-id="element-1230">
            <div className="flex-grow h-px bg-gray-200" data-id="element-1231"></div>
            <div className="px-6" data-id="element-1232">
              <div className="w-3 h-3 rounded-full accent-bg" data-id="element-1233"></div>
            </div>
            <div className="flex-grow h-px bg-gray-200" data-id="element-1234"></div>
          </div>
        </div>
      </section>
    </div>;
}